import
React
from 'react';

import {
  SessionsKeys,
  PrepaidFibreUrls
} from 'src/Common/constants';

import {
  SalesContext
} from 'src/Context/SalesContext';

import {
  CallIconBlack,
  FilterLogo,
  VettingLeftArrow,
  WhiteTick
} from 'src/Components/Common/Svg';

import {
  getPackageSuggestions
} from 'src/Services/Services';

import {
  installationAddressNullCheck
} from 'src/Utility/sanitizers';

import {
  getPageArray,
  isMobileView
} from 'src/Utility/utility';

import {
  tagOnChooseFibrePlan
} from 'src/Tagging/SalesTagging';

import {
  Filters,
  Packages,
  HelpMeChoose
} from 'src/UI/ChoosePlan/components';

import './ChoosePlan.css';

class ChoosePlan extends React.Component {

  static contextType = SalesContext;

  state = {
    showFilters: false
  }

  appProactiveSalesFlag = false;
  miniAppProactiveSalesFlag = false;
  availableDeals = null;
  packages = null;
  downloadSpeedArr = []

  async componentDidMount() {

    const appProactiveSales = sessionStorage.getItem(SessionsKeys.ProactiveSalesFlag);
    this.appProactiveSalesFlag = appProactiveSales && appProactiveSales.toUpperCase() === 'TRUE';

    const miniAppProactiveSales = sessionStorage.getItem(SessionsKeys.FTTH_MA);
    this.miniAppProactiveSalesFlag = miniAppProactiveSales && miniAppProactiveSales.toUpperCase() === 'TRUE';

    this.context.setLeadAdditionalServices([]);
    this.context.setShowSpinner(true);

    let data = JSON.parse(sessionStorage.getItem(SessionsKeys.FibreLeadsAddress));
    let installationAddress = {};

    if (data?.address_components) {

      const nullCheckedAddress = installationAddressNullCheck(data);
      const streetAddress = `${ nullCheckedAddress?.street_number?.long_name || '' } ${ nullCheckedAddress?.route?.long_name || '' }`;

      installationAddress = {
        unitNumber: nullCheckedAddress?.unit?.long_name || '',
        buildingName: nullCheckedAddress?.building?.long_name || '',
        streetNumber: nullCheckedAddress?.street_number?.long_name || '',
        streetAddress: `${ streetAddress || '' } ${ nullCheckedAddress?.premise?.long_name || '' }`,
        streetName: nullCheckedAddress?.route?.long_name || nullCheckedAddress?.premise?.long_name || '',
        suburb: nullCheckedAddress?.sublocality_level_1?.long_name || nullCheckedAddress?.sublocality_level_2?.long_name || '',
        city: nullCheckedAddress?.locality?.long_name,
        province: nullCheckedAddress?.administrative_area_level_1?.long_name,
        postalCode: nullCheckedAddress?.postal_street_code?.long_name || nullCheckedAddress?.postal_code?.long_name,
        latitude: `${ data?.geometry?.location?.lat }`,
        longitude: `${ data?.geometry?.location?.lng }`,
        docid: data?.docid,
        seoid: data?.seoid,
        formattedAddress: data?.formatted_address || `${ nullCheckedAddress?.street_number?.long_name || '' } ${ nullCheckedAddress?.route?.long_name || '' }, ${ nullCheckedAddress?.sublocality_level_1?.long_name || '' }, ${ nullCheckedAddress?.locality?.long_name || '' }, ${ nullCheckedAddress?.postal_street_code?.long_name || nullCheckedAddress?.postal_code?.long_name || '' }`
      };

      this.context.setInstallationAddress(installationAddress);
    } else if (data?.address) {

      if (sessionStorage.getItem(SessionsKeys.Products)) {

        sessionStorage.removeItem(SessionsKeys.Products);
      }

      installationAddress = {
        unitNumber: '',
        buildingName: '',
        streetNumber: data?.address?.streetNumber || '',
        streetAddress: `${ data?.address?.streetNumber || '' } ${ data?.address?.route || '' } ${ data?.address?.premise || '' }`,
        streetName: data?.address?.route || data?.address?.premise || '',
        suburb: data?.address?.suburb,
        city: data?.address?.town,
        province: data?.address?.province,
        postalCode: data?.address?.postStreet,
        latitude: `${ data?.address?.latitude }`,
        longitude: `${ data?.address?.longitude }`,
        docid: data?.address?.docid,
        seoid: data?.address?.seoid,
        formattedAddress: data?.address?.formattedAddress || `${ data?.address?.streetNumber || '' } ${ data?.address?.route || '' } ${ data?.address?.premise || '' }, ${ data?.address?.suburb || '' }, ${ data?.address?.town || '' }, ${ data?.address?.postStreet || '' }`
      };

      this.context.setInstallationAddress(installationAddress);
    } else {

      window.location.href = '/vodacom/fibre/sales/leads';

      return;
    }

    this.context.setAdditionalVas(null);
    this.context.setSelectedAdditionalServices({ key: 'superWifi', value: false });

    const getProducts = JSON.parse(sessionStorage.getItem(SessionsKeys.Products));
    let allProducts = getProducts?.products;
    const allAvailableDeals = getProducts?.availableDeals;

    if (allAvailableDeals) {

      this.availableDeals = allAvailableDeals;
      this.context.setSelectedPackageType(allAvailableDeals[0]);
    }

    if (allProducts) {

      this.context.setProviderPackages(allProducts);
      this.context.setPageNos(getPageArray([ allProducts ]));
      this.context.setFilters({
        downloadSpeed: this.determineSpeedFilters(allProducts, allAvailableDeals[0]),
        onPromotion: false
      });
    } else {

      await getPackageSuggestions(installationAddress.latitude, installationAddress.longitude)
        .then((res) => {

          if (res && res?.result && res?.result?.products && res.result.products.length > 0) {
            allProducts = res.result.products;
            sessionStorage.setItem(SessionsKeys.Products, JSON.stringify(res.result));
            this.context.setProviderPackages(allProducts);
            this.context.setPageNos(getPageArray(res.result.products));
            this.availableDeals = res.result.availableDeals;
            this.context.setFilters({
              downloadSpeed: this.determineSpeedFilters(res.result.products, this.availableDeals[0]),
              onPromotion: false
            });
          } else {

            this.context.setProviderPackages(null);
            this.context.setPageNos(null);
          }
        })
        .catch((_error) => {

          this.context.setProviderPackages(null);
        });
    }

    let isPrepaid = false;

    if (allProducts && allProducts.length > 0) {

      let providerList = [];
      for (const key in allProducts) {

        providerList.push(allProducts[key].provider);
      }

      let uniqueList = [ ...new Set(providerList) ];
      tagOnChooseFibrePlan(this.appProactiveSalesFlag, this.miniAppProactiveSalesFlag, uniqueList);
      this.setDifferentPackageType(this.availableDeals[0]);
      this.context.setPageNos(getPageArray([ allProducts ]), (() => this.determinePackages()));
      this.context.setUnselectedContractCover(false);

      this.availableDeals = [];

      for (let i = 0; i < allProducts.length; i++) {

        this.availableDeals.push(allProducts[i].dealType);
      }

      this.availableDeals = [ ...new Set(this.availableDeals) ];

      uniqueList = uniqueList.map(provider => provider.toUpperCase());

      if (uniqueList.includes('VUMATEL REACH') && uniqueList.length === 1) {

        isPrepaid = true;

        const url = `${ PrepaidFibreUrls[window.location.hostname] }?address=${ installationAddress.formattedAddress }&lat=${ installationAddress.latitude }&lng=${ installationAddress.longitude }`;

        window.location.replace(url);
      }
    }

    const delay = (delayInms) => {
      return new Promise(resolve => setTimeout(resolve, delayInms));
    };

    await delay(isPrepaid ? 2000 : 0);

    this.context.setShowSpinner(false);
  }

  setDifferentPackageType(packageType, packages) {

    let products = [];

    if (Array.isArray(packages)) {

      for (let index = 0; index < packages.length; index++) {
        if (packageType === packages[index].dealType) {
          products.push(packages[index]);
        }
      }
    }

    return (products);
  }

  determineSpeedFilters(packages, packageType) {

    let downloadSpeedObj = [];

    if (packages?.length > 0) {

      packages.forEach(item => {

        if (packageType === item.dealType) {
          downloadSpeedObj.push(item.download);
        }
      });
    }

    return [ ...new Set(downloadSpeedObj) ];
  }

  changeAddress() {

    window.location.href = '/vodacom/fibre/sales/leads';
  }

  filterPackages(packages, filters) {

    let packagesCopy = packages;
    let isPromotion = filters?.includes('Show promotions only');

    if (isPromotion) {

      packagesCopy = packagesCopy?.filter(function (item) {
        return (item.onDiscount);
      });
      if (filters?.length > 1) {

        packagesCopy = packagesCopy?.filter(function (item) {
          return filters?.includes(item.download);
        });
      }
    } else {

      packagesCopy = packagesCopy?.filter(function (item) {
        return filters?.includes(item.download);
      });
    }

    return (packagesCopy);
  }

  getHighestDiscountedAmount = (contractTerms) => {

    for (const contractTerm of contractTerms) {

      if (contractTerm.discountAmount) {

        return (parseFloat(contractTerm.discountAmount));
      }
    }

    return 0;
  };

  determinePackages = () => {

    let packages = this.context?.providerPackages;
    let filters = this.context?.filterList;
    let pageNo = this.context.selectedPageNo;
    let isHelpMeChoose = this.context?.helpMeChoosePackages?.length > 0;
    let packagesCopy = [];
    let priceSortedPackages = [];
    this.downloadSpeedArr = [];

    for (let index = 0; index < packages?.length; index++) {

      const highestDiscountedAmount = this.getHighestDiscountedAmount(packages[index]?.contractTerms);
      const discountedPrice = highestDiscountedAmount
        ? (parseInt(packages[index].productPrice.value) - highestDiscountedAmount).toFixed(2)
        : parseInt(packages[index].productPrice.value);

      priceSortedPackages.push({
        ...packages[index],
        discountedPrice: discountedPrice
      });
    }

    priceSortedPackages.sort((a, b) => parseFloat(a.discountedPrice) - parseFloat(b.discountedPrice));
    packages = priceSortedPackages;

    if (isHelpMeChoose) {

      let helpMeChoosePackages = this.context?.helpMeChoosePackages;
      if (helpMeChoosePackages[0] !== 'No packages') {
        helpMeChoosePackages.map((item) => {
          item.isRecommended = true;
          packagesCopy.push(item);
        });
      }
    }

    packagesCopy.push(...packages);

    packagesCopy = this.setDifferentPackageType(this.context.selectedPackageType, packagesCopy);

    for (let index = 0; index < packagesCopy?.length; index++) {
      if (this.context.selectedPackageType == packagesCopy[index]?.dealType) {
        this.downloadSpeedArr.push(packagesCopy[index]?.download);
      }
    }
    this.downloadSpeedArr = [ ...new Set(this.downloadSpeedArr) ];

    if (filters && filters.length > 0) {
      packagesCopy = this.filterPackages(packagesCopy, filters);
    }

    this.context.setPageNos(getPageArray([ packagesCopy ]));

    // const first = 12 * (pageNo - 1);
    // const last = (pageNo === this.context.pageNos?.length) ? packagesCopy?.length : 12 * pageNo;
    // packagesCopy = packagesCopy?.slice(first, last);

    this.packages = packagesCopy;
  }

  showCallMeBack = () => {
    this.context.setShowCallMeBack(true);
  }

  toggleFilter = () => {
    this.setState({
      showFilters: !this.state.showFilters
    });
  }

  render() {

    return (
      <div className="choose-plan-page-wrapper">

        { !this.appProactiveSalesFlag
          ? <div className="choose-plan-coverage-banner">
            <div className="choose-plan-coverage-header-wrapper">
              <div className="choose-plan-coverage-icon"><WhiteTick></WhiteTick></div>
            </div>
            <div className="choose-plan-coverage-address-wrapper">
              <div className="choose-plan-coverage-address">Fibre is available at {this?.context?.installationAddress?.formattedAddress}</div>
              <div className="choose-plan-coverage-change-address" onClick={() => {
                this.changeAddress();
              }}>Change address</div>
            </div>
          </div>
          : null
        }

        <div className="choose-plan-back" onClick={this.changeAddress}>
          <div className="choose-plan-back-arrow">
            <VettingLeftArrow />
          </div>
          <span className="choose-plan-back-title">
            Back
          </span>
        </div>

        <div className='choose-plan-content-section'>

          { !this.appProactiveSalesFlag &&

            <div className="choose-plan-title">Uncapped fibre deals</div>
          }

          <div className='choose-plan-title-subtext'>Use the filters below to find exactly what you're looking for</div>

          <div className='choose-plan-buttons-section'>
            <div
              className={this.context?.filterList?.length > 0 ? 'choose-plan-filter-button-numbers' : 'choose-plan-filter-button'}
              onClick={this.toggleFilter}>

              <div className='choose-plan-filter-button-logo'>
                <FilterLogo />
              </div>

              Filter deals

              {
                this.context?.filterList?.length > 0 &&

                <div className='choose-plan-filter-button-number'>
                  {this.context?.filterList?.length}
                </div>
              }

            </div>

            <div
              className='choose-plan-call-me-back'
              onClick={() =>  this.showCallMeBack() }>

              { !isMobileView() &&

                <div className='choose-plan-call-me-back-icon'>
                  <CallIconBlack />
                </div>
              }

              Call me back
            </div>

            <div className='choose-plan-hmc-button'>

              <HelpMeChoose determinePackages={this.determinePackages} />
            </div>
          </div>

          <div className='choose-plan-main-section'>
            <div className='choose-plan-filter-section'>

              <Filters
                packages={this.packages}
                showFilters={this.state.showFilters}
                toggleFilter={this.toggleFilter}
                availableDeals={this.availableDeals}
                dealType={this.context.selectedPackageType}
                determinePackages={() => this.determinePackages()}
                downloadSpeedArr={this.downloadSpeedArr} />

            </div>
            <div className='choose-plan-packages-section'>

              <Packages packages={this.packages} determinePackages={() => this.determinePackages()} />

              {/* <Pagination
                pageNos={this.context.pageNos}
                determinePackages={() => this.determinePackages()} /> */}

            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ChoosePlan;